import TableTooltip from './TableTooltip';
import './TableTooltip.scss';

export default TableTooltip;